import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Product} from '../product';
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {filter, first, switchMap} from "rxjs/operators";

@Injectable()
export class ThemesResolver implements Resolve<Product[]|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number =  route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;

      this._store.select(fromStore.getWebsiteThemesLoaded(websiteId))
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getWebsiteThemes(websiteId))),
          first()
        )
        .subscribe((themes: Product[]) => {
          resolve(themes);
        });
    });
  }

}
